module.exports = __webpack_public_path__ + "static/media/intro-hero-formula1-2x.15934816.png";